export default __webpack_public_path__ + "static/media/circle.0edfc094.svg";